import { render, staticRenderFns } from "./Servicios.vue?vue&type=template&id=a37f0982&"
import script from "./Servicios.vue?vue&type=script&lang=js&"
export * from "./Servicios.vue?vue&type=script&lang=js&"
import style0 from "./Servicios.vue?vue&type=style&index=0&id=a37f0982&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports